import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Badge,
  Row,
  Col,
  Container,
  ListGroup,
  Image,
  Spinner,
  Modal,
  Form as BootstrapForm,
} from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getFlatById } from "../../services/Admin/adminServices";
import { uploadFile, updateAds } from "../../services/UserServices/UserService";
import FlatmateEditModal from "../Modals/FlatmateModal";
// Note: You will need to import your update service here
// import { updateFlatDetails, uploadImages } from "../../services/Admin/adminServices";\
import LocationSearchDropdown from "../components/LocationAdd2";
import toast from "react-hot-toast";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { set } from "lodash";
import { useSelector } from "react-redux";
const FlatDetailPage = () => {
  const [flat, setFlat] = useState(null);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const navigate = useNavigate();
  const [uploading, setUploading] = useState(false);
  const location = useLocation();
  const [showEdit, setShowEdit] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [existingImages, setExistingImages] = useState([]);
  const [newImages, setNewImages] = useState([]); // [{ file, preview }]
  const [initialData, setInitialData] = useState(null);
  const [showFlatmateEdit, setShowFlatmateEdit] = useState(false);
  const [videoUploading, setVideoUploading] = useState(false);
  const roleData = useSelector(
    (state) => state.role.roles
  );
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    monthlyRent: "",
    images: [],
    securityDeposit: "",
    roomType: "",
    bathroom: "",
    furnishedType: "",
    moveInDate: "",
    leasePeriod: "",
    roommate: "",
    utilityCosts: [],
  });

  const fetchFlat = async (id) => {
    try {
      setLoading(true);
      const response = await getFlatById(id);
      setFlat(response?.data?.data || null);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) fetchFlat(id);
  }, [id]);

  // Clean up Object URLs to prevent memory leaks
  useEffect(() => {
    return () => {
      newImages.forEach((img) => URL.revokeObjectURL(img.preview));
    };
  }, [newImages]);

  // --- Edit Modal Handlers ---
  const handleOpenEdit = () => {
    if (flat?.adType === "Flatmate") {
      setShowFlatmateEdit(true);
      return;
    }
    let formattedDate = "";
    if (flat?.moveInDate) {
      formattedDate = new Date(flat.moveInDate).toISOString().split("T")[0];
    }

    setInitialData({
      id: flat?._id || "",
      videos: flat?.videos || [],
      title: flat?.title || "",
      description: flat?.description || "",
      setupCost: flat?.setupCost || "",
      monthlyRent: flat?.monthlyRent || "",
      securityDeposit: flat?.securityDeposit || "",
      roomType: flat?.roomType || "",
      bathroom: flat?.bathroom || "",
      furnishedType: flat?.furnishedType || "",
      moveInDate: formattedDate,
      leasePeriod: flat?.leasePeriod || "",
      roommate: flat?.roommate || "",
      moveInTimeline: flat?.moveInTimeline || "",
      utilityCosts: flat?.utilityCosts
        ? JSON.parse(JSON.stringify(flat.utilityCosts))
        : [],
      images: flat?.images || [],
      street: flat?.street || "",
      flatOrSuite: flat?.flatOrSuite || "",
      city: flat?.city || "",
      state: flat?.state || "",
      pinCode: flat?.pinCode || "",
      country: flat?.country || "",
      address: flat?.address || "",
      lat: flat?.location?.coordinates[1] || "",
      long: flat?.location?.coordinates[0] || "",
    });
    setExistingImages(flat?.images || []);
    setNewImages([]);
    setShowEdit(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Utility List Handlers
  const handleUtilityChange = (index, field, value) => {
    const updatedUtilities = [...formData.utilityCosts];
    updatedUtilities[index][field] = value;
    setFormData({ ...formData, utilityCosts: updatedUtilities });
  };

  const addUtility = () => {
    setFormData({
      ...formData,
      utilityCosts: [
        ...formData.utilityCosts,
        { label: "", amount: "", frequency: "per month" },
      ],
    });
  };

  const removeUtility = (index) => {
    const updatedUtilities = formData.utilityCosts.filter(
      (_, i) => i !== index,
    );
    setFormData({ ...formData, utilityCosts: updatedUtilities });
  };

  // Image Management Handlers
  const handleImageSelect = async (event, setFieldValue, values) => {
    const files = Array.from(event.target.files);
    const currentCount = values.images?.length || 0;

    // 1. Check if they are already at the limit
    if (currentCount >= 5) {
      toast.error("You have already uploaded the maximum limit of 5 images.");
      event.target.value = ""; // Clear input selection
      return;
    }

    // 2. Calculate remaining slots and slice selection if it exceeds remaining space
    const remainingSlots = 5 - currentCount;
    let filesToUpload = files;

    if (files.length > remainingSlots) {
      toast.warn(
        `You can only add ${remainingSlots} more image(s). Only the first ${remainingSlots} will be uploaded.`,
      );
      filesToUpload = files.slice(0, remainingSlots);
    }

    // 3. Process uploads sequentially with proper loading and state management
    setUploading(true);

    // Use a local mutable array copy to accumulate links and avoid Formik stale-closure bugs
    let updatedImagesList = [...values.images];

    try {
      for (const file of filesToUpload) {
        const formData = new FormData();
        formData.append("file", file);

        try {
          const res = await uploadFile(formData);
          const uploadedUrl = res?.data?.data?.fileUrl;

          if (uploadedUrl) {
            updatedImagesList.push(uploadedUrl);
            // Update Formik dynamically so user sees previews populate one by one
            setFieldValue("images", [...updatedImagesList]);
          }
        } catch (err) {
          console.error(`Upload failed for ${file.name}:`, err);
          toast.error(`Failed to upload ${file.name}`);
        }
      }
    } finally {
      setUploading(false);
      event.target.value = ""; // Clear file input field string so users can pick again if needed
    }
  };

  const handleVideoSelect = async (event, setFieldValue) => {
    const file = event.target.files[0];
    if (!file) return;

    // 1. Validate file extension matches a video format
    if (!file.type.startsWith("video/")) {
      toast.error("Please select a valid video file (MP4, WebM, etc.).");
      event.target.value = "";
      return;
    }

    // 2. Set an optional file size ceiling safeguard (e.g., 50MB)
    const maxLimit = 50 * 1024 * 1024; // 50 Megabytes
    if (file.size > maxLimit) {
      toast.error(
        "Video file size is too large! Maximum limit allowed is 50MB.",
      );
      event.target.value = "";
      return;
    }

    // 3. Dispatch data payload through execution pipeline
    setVideoUploading(true);
    const formData = new FormData();
    formData.append("file", file);

    try {
      const res = await uploadFile(formData);
      const uploadedUrl = res?.data?.data?.fileUrl;

      if (uploadedUrl) {
        // Direct assignment into the first array slot index [0]
        setFieldValue("videos", [uploadedUrl]);
        toast.success("Video tour uploaded successfully!");
      }
    } catch (err) {
      console.error("Video asset upload failed:", err);
      toast.error("Failed to upload the video tour.");
    } finally {
      setVideoUploading(false);
      event.target.value = ""; // Flush DOM element selection reference
    }
  };

  const removeExistingImage = (indexToRemove) => {
    setExistingImages((prev) =>
      prev.filter((_, index) => index !== indexToRemove),
    );
  };

  const removeNewImage = (indexToRemove) => {
    setNewImages((prev) => {
      const filtered = prev.filter((_, index) => index !== indexToRemove);
      URL.revokeObjectURL(prev[indexToRemove].preview); // Free memory
      return filtered;
    });
  };
  const listingValidationSchema = Yup.object().shape({
    title: Yup.string().required("Title is required"),

    monthlyRent: Yup.number()
      .typeError("Must be a number")
      .required("Monthly rent is required")
      .positive("Must be greater than zero"),
    securityDeposit: Yup.number()
      .typeError("Must be a number")
      .required("Security deposit is required")
      .min(0, "Cannot be negative"),
    setupCost: Yup.number()
      .typeError("Must be a number")
      .required("Setup cost is required")
      .min(0, "Cannot be negative"),
    moveInDate: Yup.date().required("Move-in date is required"),
    leasePeriod: Yup.string().required("Lease period is required"),
    moveInTimeline: Yup.string().required("Timeline is required"),
    street: Yup.string().required("Street is required"),
    city: Yup.string().required("City is required"),
    state: Yup.string().required("State is required"),
    pinCode: Yup.string().required("Pin code is required"),
    country: Yup.string().required("Country is required"),
    address: Yup.string().required("Address is required"),
    roomType: Yup.string().required("Room type is required"),
    bathroom: Yup.string().required("Bathroom type is required"),
    furnishedType: Yup.string().required("Furnished type is required"),
    roommate: Yup.number()
      .typeError("Must be a number")
      .required("Number of roommates is required")
      .min(0, "Cannot be negative"),
    utilityCosts: Yup.array().of(
      Yup.object().shape({
        label: Yup.string().required("Label is required"),
        amount: Yup.number()
          .typeError("Must be a number")
          .required("Amount is required")
          .min(0, "Cannot be negative"),
      }),
    ),
  });

  const handleSave = async (values) => {
    try {
      setIsSaving(true);
      const payload = {
        ...values,
        utilityCosts: values.utilityCosts.map(({ _id, ...rest }) => rest),
        securityDeposit: String(values.securityDeposit),
        setupCost: String(values.setupCost),
      };
      await updateAds(payload);
      toast.success("Ads updated successfully!");
      setShowEdit(false);
      fetchFlat(id); // Refresh Data
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.data || "Failed to update listing.");
    } finally {
      setIsSaving(false);
    }
  };

  if (loading) {
    return (
      <Container
        className="mt-5 d-flex flex-column align-items-center justify-content-center"
        style={{ minHeight: "50vh" }}
      >
        <Spinner animation="border" style={{ color: "#E5484D" }} />
        <p className="mt-3 text-muted">Loading property details...</p>
      </Container>
    );
  }

  if (!flat) {
    return (
      <Container className="mt-5 text-center">
        <h4 className="text-muted">Property details not found.</h4>
        <Button
          variant="outline-dark"
          size="sm"
          className="mt-3"
          onClick={() => navigate(-1)}
        >
          &larr; Back
        </Button>
      </Container>
    );
  }

  return (
    <Container className="mt-4 mb-5">
      {/* 🌟 Header Section */}
      <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3">
        <div>
          <Button
            variant="light"
            size="sm"
            className="mb-2 shadow-sm"
            onClick={() => navigate(-1)}
          >
            &larr; Back
          </Button>
          <h2 style={{ color: "#E5484D", fontWeight: "bold", margin: 0 }}>
            Ads Details
          </h2>
        </div>

        {roleData ? roleData?.adsManagement?.isUpdate &&
          <Button
            variant="primary"
            onClick={handleOpenEdit}
            style={{ backgroundColor: "#E5484D", borderColor: "#E5484D" }}
            className="shadow-sm px-4"
          >
            <i className="bi bi-pencil-square me-2"></i> Edit Listing
          </Button> : <Button
            variant="primary"
            onClick={handleOpenEdit}
            style={{ backgroundColor: "#E5484D", borderColor: "#E5484D" }}
            className="shadow-sm px-4"
          >
          <i className="bi bi-pencil-square me-2"></i> Edit Listing
        </Button>}
      </div>



      <Card className="shadow-lg border-0 rounded-4 overflow-hidden mb-4">
        <Row className="g-0">
          {flat?.adType === "Flatmate" ? (
            ""
          ) : (
            <Col md={7}>
              <div className="p-2">
                <Row className="g-2">
                  {(flat?.images?.length
                    ? flat.images
                    : [
                      "https://via.placeholder.com/800x600?text=No+Image+Available",
                    ]
                  ).map((img, index) => (
                    <Col xs={6} key={index}>
                      <div
                        style={{
                          height: "180px",
                          backgroundImage: `url(${img})`,
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                          borderRadius: "12px",
                          cursor: "pointer",
                          border: "1px solid #eee",
                        }}
                      />
                    </Col>
                  ))}
                </Row>
              </div>
            </Col>
          )}

          <Col md={ flat?.adType === "Flatmate" ? 8 : 5}>
            <Card.Body className="p-4 d-flex flex-column h-100 bg-white">
              <div className="d-flex justify-content-between align-items-start mb-2">
                <div>
                  {flat?.adminApproveStatus && (
                    <Badge
                      bg={`${flat?.adminApproveStatus ? (flat?.adminApproveStatus.toLowerCase() === "approved" ? "success" : "danger") : "info"}`}
                      className="px-3 py-2 rounded-pill"
                    >
                      {flat.adminApproveStatus}
                    </Badge>
                  )}
                </div>
                {flat?.createdAt && (
                  <small className="text-muted">
                    Listed: {new Date(flat.createdAt).toLocaleDateString()}
                  </small>
                )}
              </div>

              {flat?.title && (
                <h3 className="fw-bold mt-2 text-capitalize">{flat.title}</h3>
              )}

              {flat?.adType === "Flatmate"
                ? flat?.address && (
                  <p className="mb-4" style={{ fontSize: "1.1rem" }}>
                    <i className="bi bi-geo-alt-fill text-danger me-2"></i>
                    <span className="text-muted">Preferred Area:</span>{" "}
                    <span className="fw-bold">{flat.address}</span>
                    {flat?.pinCode ? (
                      <span className="text-muted"> ({flat?.pinCode})</span>
                    ) : (
                      ""
                    )}
                  </p>
                )
                : flat?.street && (
                  <p
                    className="text-muted mb-4"
                    style={{ fontSize: "1.1rem" }}
                  >
                    <i className="bi bi-geo-alt-fill text-danger me-2"></i>
                    {flat.street} ,{flat?.flatOrSuite}, {flat.city},{" "}
                    {flat.state} {flat?.pinCode} ,{flat?.country}
                  </p>
                )}

              {flat?.adType === "Flatmate" ? (
                <div className="mb-4">
                  <div className="d-flex flex-wrap align-items-center">
                    <div className="pe-4">
                      <span className="fs-6 text-muted fw-normal">
                        Min Budget
                      </span>
                      <h2 className="mb-0 fw-bold" style={{ color: "#E5484D" }}>
                        ₹ {Number(flat.minBudget).toLocaleString("en-IN")}
                      </h2>
                    </div>

                    <div
                      style={{ borderLeft: "2px solid #adb5bd" }} className="ps-4 ms-4">
                      <span className="fs-6 text-muted fw-normal">
                        Max Budget
                      </span>
                      <h2 className="mb-0 fw-bold" style={{ color: "#E5484D" }}>
                        ₹ {Number(flat.maxBudget).toLocaleString("en-IN")}
                      </h2>
                    </div>
                  </div>
                </div>
              ) : (
                <h2
                  style={{ color: "#E5484D", fontWeight: "800" }}
                  className="mb-4"
                >
                  ₹ {Number(flat.monthlyRent).toLocaleString("en-IN")}{" "}
                  <span className="fs-6 text-muted fw-normal">/ month</span>
                </h2>
              )}

              {flat?.adType === "Flatmate" ? (
                <div>
                  <span className="fs-6 text-muted fw-normal">
                    Move In Timeline
                  </span>
                  <span className="fw-bold">
                    {" "}
                    {flat?.moveInTimeline === "immediate"
                      ? "Immediately"
                      : flat?.moveInTimeline === "within2Weeks"
                        ? "Within 2 Weeks"
                        : flat?.moveInTimeline === "within1Month"
                          ? "Within 1 Month"
                          : flat?.moveInTimeline === "flexible"
                            ? "Flexible"
                            : ""}
                  </span>

                  <div

                    className="   w-100"
                  >
                    {flat.adminApproveStatus === "Approved" && (
                      <>
                        {flat.isExpire ? (
                          <div className="mt-3">
                            <p className="text-muted mb-2">Expired On</p>
                            <h6 className="fw-bold mb-0">
                              {new Date(flat.updatedAt).toLocaleDateString(undefined, {
                                year: "numeric",
                                month: "long",
                                day: "numeric",
                              })}
                            </h6>
                          </div>
                        ) : (
                          <div
                            className="d-flex flex-wrap mt-3"
                            style={{ columnGap: "6rem", rowGap: "2rem" }}
                          >
                            {flat.expireDate && (
                              <div>
                                <p className="text-muted mb-2">Expires On</p>
                                <h6 className="fw-bold mb-0">
                                  {new Date(
                                    new Date(flat.expireDate || flat.createdAt).getTime() +
                                    30 * 24 * 60 * 60 * 1000
                                  ).toLocaleDateString(undefined, {
                                    year: "numeric",
                                    month: "long",
                                    day: "numeric",
                                  })}
                                </h6>
                              </div>
                            )}

                            {flat.remainingExpireDays > 0 && (
                              <div>
                                <p className="text-muted mb-2">Remaining Days</p>
                                <h6 className="fw-bold mb-0">
                                  {flat.remainingExpireDays}
                                </h6>
                              </div>
                            )}
                          </div>
                        )}

                        {flat.reNewAdDateHistory?.length > 0 && (
                          <div className="mt-5">
                            <p className="text-muted mb-3">Renewal Date History</p>

                            <div className="fw-bold d-flex flex-column" style={{ rowGap: "0.75rem" }}>
                              {flat.reNewAdDateHistory.map((date, index) => (
                                <div key={index}>
                                  •{" "}
                                  {new Date(date).toLocaleDateString(undefined, {
                                    year: "numeric",
                                    month: "long",
                                    day: "numeric",
                                  })}
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </>
                    )}
                  </div>


                </div>
              ) : (
                ""
              )}

              {/* {flat?.monthlyRent !== undefined && flat?.monthlyRent !== null && (
                <h2 style={{ color: "#E5484D", fontWeight: "800" }} className="mb-4">
                  ₹ {Number(flat.monthlyRent).toLocaleString("en-IN")} <span className="fs-6 text-muted fw-normal">/ month</span>
                </h2>
              )} */}

              {flat?.adType === "Flatmate" ? (
                ""
              ) : (
                <Row className="text-center mb-4 g-2">
                  {flat?.roommate > 0 && (
                    <Col xs={6} md={3}>
                      <div
                        style={{ backgroundColor: "#E5484D" }}
                        className="p-2 rounded-3 h-100 d-flex flex-column justify-content-center"
                      >
                        <h6 className="mb-0 fw-bold text-white">
                          {flat.roommate}
                        </h6>
                        <small
                          className="text-white"
                          style={{ fontSize: "0.8rem" }}
                        >
                          Roommates
                        </small>
                      </div>
                    </Col>
                  )}
                  {flat?.bathroom && (
                    <Col xs={6} md={3}>
                      <div
                        style={{ backgroundColor: "#E5484D" }}
                        className="p-2 rounded-3 h-100 d-flex flex-column justify-content-center"
                      >
                        <h6 className="mb-0 fw-bold text-white">
                          {flat.bathroom}
                        </h6>
                        <small
                          className="text-white"
                          style={{ fontSize: "0.8rem" }}
                        >
                          Bathroom
                        </small>
                      </div>
                    </Col>
                  )}
                  {flat?.furnishedType && (
                    <Col xs={6} md={3}>
                      <div
                        style={{ backgroundColor: "#E5484D" }}
                        className="p-2 rounded-3 h-100 d-flex flex-column justify-content-center"
                      >
                        <h6 className="mb-0 fw-bold text-white">
                          {flat.furnishedType}
                        </h6>
                        <small
                          className="text-white"
                          style={{ fontSize: "0.8rem" }}
                        >
                          Furnishing
                        </small>
                      </div>
                    </Col>
                  )}
                  {flat?.roomType && (
                    <Col xs={6} md={3}>
                      <div
                        style={{ backgroundColor: "#E5484D" }}
                        className="p-2 rounded-3 h-100 d-flex flex-column justify-content-center"
                      >
                        <h6 className="mb-0 fw-bold text-white">
                          {flat.roomType}
                        </h6>
                        <small
                          className="text-white"
                          style={{ fontSize: "0.8rem" }}
                        >
                          Room Type
                        </small>
                      </div>
                    </Col>
                  )}
                </Row>
              )}

              {flat?.description && (
                <div className="flex-grow-1">
                  <h5 className="fw-bold fs-6">Description</h5>
                  <p className="text-muted lh-sm">{flat.description}</p>
                </div>
              )}
            </Card.Body>
          </Col>


         
          
        {flat?.user && flat?.adType === "Flatmate" && (
          <Col md={4}>
            <Card className="shadow-sm border-0 rounded-4 h-100">
              <Card.Body className="p-4 text-center">
                <h5 className="fw-bold mb-4 text-start">Listed By</h5>
                <Image
                  src={
                    flat?.user?.image ||
                    "https://www.pngfind.com/pngs/m/610-6104451_image-placeholder-png-user-profile-placeholder-image-png.png"
                  }
                  roundedCircle
                  width={100}
                  height={100}
                  className="mb-3 object-fit-cover  shadow-sm border"
                  alt={flat?.user?.name || "Host"}
                />
                {flat?.user?.name && (
                  <h5
                    style={{ color: "blue" }}
                    onClick={() => navigate(`/user-detail/${flat?.user?._id}`)}
                    className="fw-bold mb-1 cursor-pointer"
                  >
                    {flat.user.name}
                  </h5>
                )}
                {flat?.user?.occupation && (
                  <p className="text-muted mb-3">{flat.user.occupation}</p>
                )}

                {(flat?.user?.basicInfo?.bio || flat?.user?.about) && (
                  <div className="bg-white p-3 rounded-3 text-start mb-3">
                    <small className="text-muted d-block mb-1">About</small>
                    <span className="fw-medium" style={{ fontSize: "0.9rem" }}>
                      {flat?.user?.basicInfo?.bio || flat?.user?.about}
                    </span>
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>
        )}
        
        </Row>
      </Card>

      {flat?.adType === "Flatmate" ? (
        ""
      ) : (
        <Card className="shadow-sm border-0 rounded-4 mb-4">
          <Card.Body>
            <h4
              className="text-center fw-bold mb-4"
              style={{ color: "#E5484D" }}
            >
              <i className="bi bi-camera-video-fill me-2"></i>
              Ads Video
            </h4>

            <Row className="justify-content-center">
              <Col md={8}>
                <div
                  className="bg-black rounded-4 d-flex align-items-center justify-content-center overflow-hidden"
                  style={{ minHeight: "400px" }}
                >
                  {flat?.videos?.length > 0 ? (
                    <video
                      src={flat.videos[0]}
                      controls
                      autoPlay
                      style={{
                        maxWidth: "100%",
                        maxHeight: "500px",
                        objectFit: "contain",
                      }}
                    />
                  ) : (
                    <div className="text-center text-light p-5">
                      <i className="bi bi-video-off fs-1 d-block mb-2"></i>
                      <span>No Video Available</span>
                    </div>
                  )}
                </div>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      )}



      {flat.rejectReason && flat.adminApproveStatus === "Reject" && (
        <Card className="shadow-sm border-0 rounded-4 h-100 mt-2">
          <Card.Body className="p-4">
            <h5 className="fw-bold mb-4">Reject Reason :</h5>
            <Row className="mb-4">
              <Col sm={4} className="mb-3 mb-sm-0">
                <p className="fw-bold">{flat?.rejectReason}</p>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      )}



      <Row className="g-4">
        
        <Col md={8}>
          {flat?.adType === "Flatmate" ? (
            "") : (
            <Card className="shadow-sm border-0 rounded-4 h-100">
              <Card.Body className="p-4">
                <h5 className="fw-bold mb-4">Financial & Lease Details</h5>
                <Row className="mb-4">
                  {flat?.securityDeposit && (
                    <Col sm={4} className="mb-3 mb-sm-0">
                      <p className="text-muted mb-1">Security Deposit</p>
                      <h6 className="fw-bold">
                        ₹ {Number(flat.securityDeposit).toLocaleString("en-IN")}
                      </h6>
                    </Col>
                  )}
                  {flat?.setupCost && (
                    <Col sm={4} className="mb-3 mb-sm-0">
                      <p className="text-muted mb-1">Setup Cost</p>
                      <h6 className="fw-bold">
                        ₹ {Number(flat.setupCost).toLocaleString("en-IN")}
                      </h6>
                    </Col>
                  )}
                  {flat?.leasePeriod && (
                    <Col sm={4}>
                      <p className="text-muted mb-1">Lease Period</p>
                      <h6 className="fw-bold text-uppercase">
                        {flat.leasePeriod}
                      </h6>
                    </Col>
                  )}
                </Row>

                <Row className="mb-4">
                  {flat?.moveInDate && (
                    <Col sm={6} className="mb-3 mb-sm-0">
                      <p className="text-muted mb-1">Move In Date</p>
                      <h6 className="fw-bold">
                        {new Date(flat.moveInDate).toLocaleDateString(
                          undefined,
                          { year: "numeric", month: "long", day: "numeric" },
                        )}
                      </h6>
                    </Col>
                  )}
                  {flat?.adType && (
                    <Col sm={6}>
                      <p className="text-muted mb-1">Property Type</p>
                      <h6 className="fw-bold">{flat.adType}</h6>
                    </Col>
                  )}
                </Row>

                {flat?.utilityCosts && flat.utilityCosts.length > 0 && (
                  <>
                    <h6 className="fw-bold mt-4 mb-3">Utility Costs</h6>
                    <ListGroup variant="flush" className="border rounded-3">
                      {flat.utilityCosts.map((utility, idx) => (
                        <ListGroup.Item
                          key={idx}
                          className="d-flex justify-content-between align-items-center bg-white"
                        >
                          <span className="fw-medium">{utility.label}</span>
                          <span className="text-danger fw-bold">
                            ₹{utility.amount}{" "}
                            <small className="text-muted fw-normal">
                              /{utility.frequency}
                            </small>
                          </span>
                        </ListGroup.Item>
                      ))}
                    </ListGroup>
                  </>
                )}

                {flat.adminApproveStatus === "Approved" ? (
                  flat?.isExpire ? (
                    <Row className="mt-4">
                      <Col sm={6} className="mb-3 mb-sm-0">
                        <p className="text-muted mb-1">Expired On</p>
                        <h6 className="fw-bold">
                          {" "}
                          {new Date(flat.updatedAt).toLocaleDateString(
                            undefined,
                            {
                              year: "numeric",
                              month: "long",
                              day: "numeric",
                            },
                          )}
                        </h6>
                      </Col>
                    </Row>
                  ) : (
                    <Row className="mt-4">
                      {flat?.expireDate && (
                        <Col sm={6} className="mb-3 mb-sm-0">
                          <p className="text-muted mb-1">Expires On</p>
                          <h6 className="fw-bold">
                            {" "}
                            {new Date(
                              new Date(flat.expireDate || flat.createdAt).getTime() +
                              30 * 24 * 60 * 60 * 1000
                            ).toLocaleDateString(undefined, {
                              year: "numeric",
                              month: "long",
                              day: "numeric",
                            })}
                          </h6>
                        </Col>
                      )}
                      {flat?.remainingExpireDays > 0 && (
                        <Col sm={6}>
                          <p className="text-muted mb-1">Remaining days </p>
                          <h6 className="fw-bold">
                            {flat.remainingExpireDays}
                          </h6>
                        </Col>
                      )}
                    </Row>
                  )
                ) : (
                  ""
                )}

                {flat.adminApproveStatus === "Approved" &&
                  flat?.reNewAdDateHistory?.length > 0 ? (
                  <Row className="mt-4">
                    <Col sm={6} className="mb-3 mb-sm-0">
                      <p className="text-muted mb-1">Renewal Date History</p>
                      <h6 className="fw-bold">
                        {" "}
                        *{" "}
                        {flat.reNewAdDateHistory.map((date, index) => (
                          <span key={index}>
                            {new Date(date).toLocaleDateString(undefined, {
                              year: "numeric",
                              month: "long",
                              day: "numeric",
                            })}
                          </span>
                        ))}
                      </h6>
                    </Col>
                  </Row>
                ) : (
                  ""
                )}
              </Card.Body>
            </Card>
          )}

        </Col>



        {flat?.user && flat?.adType === "Flat" && (
          <Col md={4}>
            <Card className="shadow-sm border-0 rounded-4 h-100">
              <Card.Body className="p-4 text-center">
                <h5 className="fw-bold mb-4 text-start">Listed By</h5>
                <Image
                  src={
                    flat?.user?.image ||
                    "https://www.pngfind.com/pngs/m/610-6104451_image-placeholder-png-user-profile-placeholder-image-png.png"
                  }
                  roundedCircle
                  width={100}
                  height={100}
                  className="mb-3 object-fit-cover  shadow-sm border"
                  alt={flat?.user?.name || "Host"}
                />
                {flat?.user?.name && (
                  <h5
                    style={{ color: "blue" }}
                    onClick={() => navigate(`/user-detail/${flat?.user?._id}`)}
                    className="fw-bold mb-1 cursor-pointer"
                  >
                    {flat.user.name}
                  </h5>
                )}
                {flat?.user?.occupation && (
                  <p className="text-muted mb-3">{flat.user.occupation}</p>
                )}

                {(flat?.user?.basicInfo?.bio || flat?.user?.about) && (
                  <div className="bg-white p-3 rounded-3 text-start mb-3">
                    <small className="text-muted d-block mb-1">About</small>
                    <span className="fw-medium" style={{ fontSize: "0.9rem" }}>
                      {flat?.user?.basicInfo?.bio || flat?.user?.about}
                    </span>
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>
        )}
      </Row>




      <Modal
        show={showEdit}
        onHide={() => setShowEdit(false)}
        size="xl"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ color: "#E5484D", fontWeight: "bold" }}>
            Edit Listing
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ backgroundColor: "#FFE4E6" }}>
          <Formik
            enableReinitialize
            initialValues={{
              id: initialData?.id || "",

              title: initialData?.title || "",
              description: initialData?.description || "",
              setupCost: initialData?.setupCost || "",
              monthlyRent: initialData?.monthlyRent || "",
              securityDeposit: initialData?.securityDeposit || "",
              moveInDate: initialData?.moveInDate || "",
              leasePeriod: initialData?.leasePeriod || "",
              roomType: initialData?.roomType || "",
              bathroom: initialData?.bathroom || "",
              images: initialData?.images || [],
              furnishedType: initialData?.furnishedType || "",
              roommate: initialData?.roommate || "",

              moveInTimeline: initialData?.moveInTimeline || "",
              utilityCosts: initialData?.utilityCosts || [],
              street: initialData?.street || "",
              flatOrSuite: initialData?.flatOrSuite || "",
              city: initialData?.city || "",
              state: initialData?.state || "",
              pinCode: initialData?.pinCode || "",
              country: initialData?.country || "",
              address: initialData?.address || "",
              lat: initialData?.lat || "",
              long: initialData?.long || "",
              videos: initialData?.videos || [],
            }}
            validationSchema={listingValidationSchema}
            onSubmit={(values) => {
              handleSave(values);
            }}
          >
            {({
              values,
              handleChange,
              handleSubmit,
              setFieldValue,
              errors,
              touched,
            }) => (
              <Form onSubmit={handleSubmit}>
                {/* ---------------- BASIC ---------------- */}
                <Card className="border-0 shadow-sm p-4 mb-4 rounded-4">
                  <h5 className="mb-3 fw-bold">Basic Information</h5>

                  <BootstrapForm.Group className="mb-3">
                    <BootstrapForm.Label>Title</BootstrapForm.Label>
                    <BootstrapForm.Control
                      name="title"
                      value={values.title}
                      onChange={handleChange}
                      isInvalid={touched.title && !!errors.title}
                    />
                    <BootstrapForm.Control.Feedback type="invalid">
                      {errors.title}
                    </BootstrapForm.Control.Feedback>
                  </BootstrapForm.Group>

                  <BootstrapForm.Group>
                    <BootstrapForm.Label>Description</BootstrapForm.Label>
                    <BootstrapForm.Control
                      as="textarea"
                      rows={4}
                      name="description"
                      value={values.description}
                      onChange={handleChange}
                    />
                  </BootstrapForm.Group>
                </Card>

                {/* ---------------- FINANCIAL ---------------- */}
                <Card className="border-0 shadow-sm p-4 mb-4 rounded-4">
                  <h5 className="mb-3 fw-bold">Financials & Timeline</h5>

                  <Row className="g-3">
                    <Col md={4}>
                      <BootstrapForm.Label>Monthly Rent</BootstrapForm.Label>
                      <BootstrapForm.Control
                        type="number"
                        name="monthlyRent"
                        value={values.monthlyRent}
                        onChange={handleChange}
                        placeholder="Monthly Rent"
                        isInvalid={touched.monthlyRent && !!errors.monthlyRent}
                      />
                      <BootstrapForm.Control.Feedback type="invalid">
                        {errors.monthlyRent}
                      </BootstrapForm.Control.Feedback>
                    </Col>

                    <Col md={4}>
                      <BootstrapForm.Label>
                        Security Deposit{" "}
                      </BootstrapForm.Label>

                      <BootstrapForm.Control
                        type="number"
                        name="securityDeposit"
                        value={values.securityDeposit}
                        onChange={handleChange}
                        placeholder="Security Deposit"
                        isInvalid={
                          touched.securityDeposit && !!errors.securityDeposit
                        }
                      />
                      <BootstrapForm.Control.Feedback type="invalid">
                        {errors.securityDeposit}
                      </BootstrapForm.Control.Feedback>
                    </Col>
                    <Col md={4}>
                      <BootstrapForm.Label>Setup Cost </BootstrapForm.Label>

                      <BootstrapForm.Control
                        type="number"
                        name="setupCost"
                        value={values.setupCost}
                        onChange={handleChange}
                        placeholder="setupCost "
                        isInvalid={touched.setupCost && !!errors.setupCost}
                      />
                      <BootstrapForm.Control.Feedback type="invalid">
                        {errors.setupCost}
                      </BootstrapForm.Control.Feedback>
                    </Col>

                    <Col md={4}>
                      <BootstrapForm.Label>Move In Date </BootstrapForm.Label>
                      <BootstrapForm.Control
                        type="date"
                        name="moveInDate"
                        value={values.moveInDate}
                        onChange={handleChange}
                        isInvalid={touched.moveInDate && !!errors.moveInDate}
                      />
                      <BootstrapForm.Control.Feedback type="invalid">
                        {errors.moveInDate}
                      </BootstrapForm.Control.Feedback>
                    </Col>

                    <Col md={4}>
                      <BootstrapForm.Label>Lease Period </BootstrapForm.Label>
                      <BootstrapForm.Select
                        name="leasePeriod"
                        value={values.leasePeriod}
                        onChange={handleChange}
                        isInvalid={touched.leasePeriod && !!errors.leasePeriod}
                      >
                        <option value="">Select...</option>
                        <option value="1m">1 month</option>

                        <option value="3m">3 months</option>
                        <option value="6m">6 months</option>
                        <option value="12m">12 months</option>
                      </BootstrapForm.Select>
                      <BootstrapForm.Control.Feedback type="invalid">
                        {errors.leasePeriod}
                      </BootstrapForm.Control.Feedback>
                    </Col>

                    <Col md={4}>
                      <BootstrapForm.Label>
                        Move In Timeline{" "}
                      </BootstrapForm.Label>
                      <BootstrapForm.Select
                        name="moveInTimeline"
                        value={values.moveInTimeline}
                        onChange={handleChange}
                        isInvalid={
                          touched.moveInTimeline && !!errors.moveInTimeline
                        }
                      >
                        <option value="">Select...</option>
                        <option value="immediate"> Immediately</option>

                        <option value="within2Weeks">Within 2 Weeks</option>
                        <option value="within1Month">Within 1 Month</option>
                        <option value="flexible">Flexible</option>
                      </BootstrapForm.Select>
                      <BootstrapForm.Control.Feedback type="invalid">
                        {errors.moveInTimeline}
                      </BootstrapForm.Control.Feedback>
                    </Col>
                  </Row>
                </Card>

                <Card className="border-0 shadow-sm p-4 mb-4 rounded-4">
                  <h5 className="mb-3 fw-bold">Location Details</h5>

                  <LocationSearchDropdown
                    onSelect={(locationData) => {
                      setFieldValue("street", locationData.streetAddress || "");
                      setFieldValue("city", locationData.city || "");
                      setFieldValue("state", locationData.state || "");
                      setFieldValue("pinCode", locationData.pincode || "");
                      setFieldValue("country", locationData.country || "");
                      setFieldValue("address", locationData.name || "");

                      setFieldValue(
                        "lat",
                        locationData.location?.coordinates?.[1] || "",
                      );

                      setFieldValue(
                        "long",
                        locationData.location?.coordinates?.[0] || "",
                      );
                    }}
                  />

                  <Row className="g-3 mt-2">
                    <Col md={6}>
                      <BootstrapForm.Label>Street</BootstrapForm.Label>
                      <BootstrapForm.Control
                        name="street"
                        value={values.street}
                        onChange={handleChange}
                        isInvalid={touched.street && !!errors.street}
                      />
                      <BootstrapForm.Control.Feedback type="invalid">
                        {errors.street}
                      </BootstrapForm.Control.Feedback>
                    </Col>

                    <Col md={6}>
                      <BootstrapForm.Label>Flat / Suite</BootstrapForm.Label>
                      <BootstrapForm.Control
                        name="flatOrSuite"
                        value={values.flatOrSuite}
                        onChange={handleChange}
                        isInvalid={touched.flatOrSuite && !!errors.flatOrSuite}
                      />
                      <BootstrapForm.Control.Feedback type="invalid">
                        {errors.flatOrSuite}
                      </BootstrapForm.Control.Feedback>
                    </Col>

                    <Col md={4}>
                      <BootstrapForm.Label>City</BootstrapForm.Label>
                      <BootstrapForm.Control
                        name="city"
                        value={values.city}
                        onChange={handleChange}
                        isInvalid={touched.city && !!errors.city}
                      />
                      <BootstrapForm.Control.Feedback type="invalid">
                        {errors.city}
                      </BootstrapForm.Control.Feedback>
                    </Col>

                    <Col md={4}>
                      <BootstrapForm.Label>State</BootstrapForm.Label>
                      <BootstrapForm.Control
                        name="state"
                        value={values.state}
                        onChange={handleChange}
                        isInvalid={touched.state && !!errors.state}
                      />
                      <BootstrapForm.Control.Feedback type="invalid">
                        {errors.state}
                      </BootstrapForm.Control.Feedback>
                    </Col>

                    <Col md={4}>
                      <BootstrapForm.Label>Pin Code</BootstrapForm.Label>
                      <BootstrapForm.Control
                        name="pinCode"
                        value={values.pinCode}
                        onChange={handleChange}
                        isInvalid={touched.pinCode && !!errors.pinCode}
                      />
                      <BootstrapForm.Control.Feedback type="invalid">
                        {errors.pinCode}
                      </BootstrapForm.Control.Feedback>
                    </Col>

                    <Col md={6}>
                      <BootstrapForm.Label>Country</BootstrapForm.Label>
                      <BootstrapForm.Control
                        name="country"
                        value={values.country}
                        onChange={handleChange}
                        isInvalid={touched.country && !!errors.country}
                      />
                      <BootstrapForm.Control.Feedback type="invalid">
                        {errors.country}
                      </BootstrapForm.Control.Feedback>
                    </Col>

                    <Col md={6}>
                      <BootstrapForm.Label>Address</BootstrapForm.Label>
                      <BootstrapForm.Control
                        name="address"
                        value={values.address}
                        onChange={handleChange}
                        isInvalid={touched.address && !!errors.address}
                      />
                      <BootstrapForm.Control.Feedback type="invalid">
                        {errors.address}
                      </BootstrapForm.Control.Feedback>
                    </Col>
                  </Row>
                </Card>

                {/* ---------------- PROPERTY ---------------- */}
                <Card className="border-0 shadow-sm p-4 mb-4 rounded-4">
                  <h5 className="mb-3 fw-bold">Property Details</h5>

                  <Row className="g-3">
                    <Col md={3}>
                      <BootstrapForm.Label>Room Type</BootstrapForm.Label>
                      <BootstrapForm.Select
                        name="roomType"
                        value={values.roomType}
                        onChange={handleChange}
                        isInvalid={touched.roomType && !!errors.roomType}
                      >
                        <option value="">Select...</option>
                        <option value="Shared">Shared</option>

                        <option value="Private">Private</option>
                      </BootstrapForm.Select>
                      <BootstrapForm.Control.Feedback type="invalid">
                        {errors.roomType}
                      </BootstrapForm.Control.Feedback>
                    </Col>

                    <Col md={3}>
                      <BootstrapForm.Label>Bathroom Type</BootstrapForm.Label>
                      <BootstrapForm.Select
                        name="bathroom"
                        value={values.bathroom}
                        onChange={handleChange}
                        isInvalid={touched.bathroom && !!errors.bathroom}
                      >
                        <option value="">Select...</option>
                        <option value="Shared">Shared</option>

                        <option value="Private">Private</option>
                      </BootstrapForm.Select>

                      <BootstrapForm.Control.Feedback type="invalid">
                        {errors.bathroom}
                      </BootstrapForm.Control.Feedback>
                    </Col>

                    <Col md={3}>
                      <BootstrapForm.Label>Furnished Type</BootstrapForm.Label>
                      <BootstrapForm.Select
                        name="furnishedType"
                        value={values.furnishedType}
                        onChange={handleChange}
                        isInvalid={
                          touched.furnishedType && !!errors.furnishedType
                        }
                      >
                        <option value="">Select...</option>
                        <option value="Furnished">Furnished</option>

                        <option value="Unfurnished">Unfurnished</option>
                      </BootstrapForm.Select>
                      <BootstrapForm.Control.Feedback type="invalid">
                        {errors.furnishedType}
                      </BootstrapForm.Control.Feedback>
                    </Col>

                    <Col md={3}>
                      <BootstrapForm.Label>Roommates</BootstrapForm.Label>
                      <BootstrapForm.Control
                        type="number"
                        name="roommate"
                        value={values.roommate}
                        onChange={handleChange}
                        placeholder="Roommates"
                        isInvalid={touched.roommate && !!errors.roommate}
                      />
                      <BootstrapForm.Control.Feedback type="invalid">
                        {errors.roommate}
                      </BootstrapForm.Control.Feedback>
                    </Col>
                  </Row>
                </Card>

                <Card className="border-0 shadow-sm p-4 mb-4 rounded-4">
                  <div className="d-flex justify-content-between mb-3">
                    <h5>Utility Costs</h5>
                    <Button
                      style={{ backgroundColor: "#E5484D", border: "none" }}
                      onClick={() => {
                        setFieldValue("utilityCosts", [
                          ...values.utilityCosts,
                          { label: "", amount: "", frequency: "per month" },
                        ]);
                      }}
                    >
                      + Add Utility
                    </Button>
                  </div>

                  {values.utilityCosts.map((u, index) => {
                    const utilErrors = errors.utilityCosts?.[index] || {};
                    const utilTouched = touched.utilityCosts?.[index] || {};

                    return (
                      <Row key={index} className="mb-2 g-2">
                        <Col md={4}>
                          <BootstrapForm.Control
                            value={u.label}
                            onChange={(e) => {
                              const updated = [...values.utilityCosts];
                              updated[index].label = e.target.value;
                              setFieldValue("utilityCosts", updated);
                            }}
                            name={`utilityCosts[${index}].label`}
                            placeholder="Label"
                            isInvalid={utilTouched.label && !!utilErrors.label}
                          />
                          <BootstrapForm.Control.Feedback type="invalid">
                            {utilErrors.label}
                          </BootstrapForm.Control.Feedback>
                        </Col>

                        <Col md={3}>
                          <BootstrapForm.Control
                            type="number"
                            value={u.amount}
                            onChange={(e) => {
                              const updated = [...values.utilityCosts];
                              updated[index].amount = e.target.value;
                              setFieldValue("utilityCosts", updated);
                            }}
                            name={`utilityCosts[${index}].amount`}
                            placeholder="Amount"
                            isInvalid={
                              utilTouched.amount && !!utilErrors.amount
                            }
                          />
                          <BootstrapForm.Control.Feedback type="invalid">
                            {utilErrors.amount}
                          </BootstrapForm.Control.Feedback>
                        </Col>

                        <Col md={2}>
                          <Button
                            variant="outline-danger"
                            onClick={() => {
                              const updated = values.utilityCosts.filter(
                                (_, i) => i !== index,
                              );
                              setFieldValue("utilityCosts", updated);
                            }}
                          >
                            Delete
                          </Button>
                        </Col>
                      </Row>
                    );
                  })}
                </Card>

                <Card className="border-0 shadow-sm p-4 mb-3 rounded-4">
                  <div className="d-flex justify-content-between align-items-center">
                    <h5 className="fw-bold mb-2">Images</h5>
                    <small className="text-muted">
                      ({values.images.length} / 5 uploaded)
                    </small>
                  </div>

                  <BootstrapForm.Control
                    accept="image/*"
                    type="file"
                    multiple
                    onChange={(e) =>
                      handleImageSelect(e, setFieldValue, values)
                    }
                    disabled={uploading || values.images.length >= 5}
                  />

                  {uploading && (
                    <div className="text-danger mt-2 d-flex align-items-center gap-2">
                      <Spinner animation="border" size="sm" />
                      <span>Uploading images, please wait...</span>
                    </div>
                  )}

                  <div className="d-flex flex-wrap gap-3 mt-3">
                    {values.images.map((img, i) => (
                      <div
                        key={i}
                        style={{
                          position: "relative",
                          width: "120px",
                          height: "120px",
                        }}
                      >
                        <Image
                          src={img}
                          fluid
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: "12px",
                            border: "1px solid #eee",
                          }}
                        />

                        <Button
                          variant="danger"
                          size="sm"
                          type="button"
                          onClick={() => {
                            const updated = values.images.filter(
                              (_, idx) => idx !== i,
                            );
                            setFieldValue("images", updated);
                          }}
                          style={{
                            position: "absolute",
                            top: "-6px",
                            right: "-6px",
                            width: "24px",
                            height: "24px",
                            borderRadius: "50%",
                            padding: 0,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                          }}
                        >
                          ×
                        </Button>
                      </div>
                    ))}
                  </div>
                </Card>

                <Card className="border-0 shadow-sm p-4 mb-3 rounded-4">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="fw-bold mb-0">Video Tour</h5>
                    {values.videos?.[0] && (
                      <small className="text-success d-flex align-items-center gap-1">
                        <i className="bi bi-check-circle-fill"></i> Ready
                      </small>
                    )}
                  </div>

                  {/* If no video has been uploaded yet, display the selection interface */}
                  {!values.videos?.[0] ? (
                    <div className="upload-dropzone">
                      <BootstrapForm.Control
                        accept="video/*"
                        type="file"
                        onChange={(e) => handleVideoSelect(e, setFieldValue)}
                        disabled={videoUploading}
                      />
                      <small className="text-muted mt-2 d-block">
                        Provide an optional video of the space. Maximum size
                        limit: 50MB.
                      </small>
                    </div>
                  ) : (
                    /* Interactive Video Render Frame Window */
                    <div
                      style={{
                        position: "relative",
                        borderRadius: "12px",
                        overflow: "hidden",
                        backgroundColor: "#000",
                        border: "1px solid #eee",
                      }}
                    >
                      <video
                        src={values.videos[0]}
                        controls
                        className="w-100"
                        style={{
                          maxHeight: "320px",
                          display: "block",
                          objectFit: "contain",
                        }}
                      />

                      <Button
                        variant="danger"
                        size="sm"
                        type="button"
                        disabled={videoUploading}
                        onClick={() => setFieldValue("videos", [])}
                        style={{
                          position: "absolute",
                          top: "12px",
                          right: "12px",
                          width: "28px",
                          height: "28px",
                          borderRadius: "50%",
                          padding: 0,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.4)",
                          zIndex: 2,
                          fontSize: "16px",
                        }}
                      >
                        ×
                      </Button>
                    </div>
                  )}

                  {/* Active background upload worker animation prompt context mapping */}
                  {videoUploading && (
                    <div className="text-danger mt-3 d-flex align-items-center gap-2">
                      <Spinner animation="border" size="sm" />
                      <span className="fw-medium">
                        Uploading video... Please don't close the modal.
                      </span>
                    </div>
                  )}
                </Card>

                <Modal.Footer>
                  <Button
                    variant="secondary"
                    onClick={() => setShowEdit(false)}
                  >
                    Cancel
                  </Button>

                  <Button
                    type="submit"
                    disabled={isSaving}
                    style={{ backgroundColor: "#E5484D" }}
                  >
                    {isSaving ? "Saving..." : "Save Changes"}
                  </Button>
                </Modal.Footer>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>

    
      <FlatmateEditModal
        show={showFlatmateEdit}
        onHide={() => setShowFlatmateEdit(false)}
        flatData={flat}
        isSaving={isSaving}
        onSave={async (values) => {
          try {
            setIsSaving(true);

            const payload = {
              id: values?.id,
              address: values.address,
              pinCode: values.pinCode,
              minBudget: values.minBudget,
              maxBudget: values.maxBudget,
              moveInTimeline: values.moveInTimeline,
            };
            await updateAds(payload);

            toast.success("Flatmate requirements updated successfully!");
            setShowFlatmateEdit(false);
            fetchFlat(id); // Reload parent screen data layout state tree
          } catch (error) {
            console.error(error);
            toast.error(
              error?.response?.data?.data || "Failed to update requirements.",
            );
          } finally {
            setIsSaving(false);
          }
        }}
      />

   
    </Container>
  );
};

export default FlatDetailPage;
